/* CIY — quick-add pill on product cards.

   Figma node 138:3979 draws a white "Add" pill top-right of every product
   card image, and the same pill as a − N + stepper once the item is in the
   cart. This drives both states for every [data-ciy-qa] on the page:
   the collection and search grids, the home page carousels, and the
   product page's related/recommended rows.

   Cart quantities come from /cart.js keyed by variant id, so a card knows
   it is already in the cart on first paint — not only after you click it.

   Styling: assets/ciy-cards.css. Markup: snippets/ciy-quick-add.liquid.  */
(function () {
  var qty = {}; // variant id -> total quantity in cart
  var keys = {}; // variant id -> cart line key (what /cart/change.js wants)
  var busy = false;

  function nodes() {
    return document.querySelectorAll('[data-ciy-qa]');
  }

  /* ---------------------------------------------------------------- paint */

  function paint() {
    nodes().forEach(function (el) {
      var add = el.querySelector('[data-ciy-qa-add]');
      var step = el.querySelector('[data-ciy-qa-step]');
      var val = el.querySelector('[data-ciy-qa-val]');
      if (!add || !step || !val) return;

      var n = qty[el.getAttribute('data-variant-id')] || 0;

      if (n > 0) {
        val.textContent = n;
        step.hidden = false;
        add.hidden = true;
        el.classList.add('is-in-cart');
      } else {
        step.hidden = true;
        add.hidden = false;
        el.classList.remove('is-in-cart');
      }
      el.classList.toggle('is-busy', busy);
    });
  }

  /* ----------------------------------------------------------------- read */

  /* One variant can sit on several cart lines (different line properties).
     The quantity shown is the total; the stepper edits the last such line,
     which is the one a card-level add would have created. */
  function absorb(cart) {
    qty = {};
    keys = {};
    (cart.items || []).forEach(function (item) {
      var v = String(item.variant_id);
      qty[v] = (qty[v] || 0) + item.quantity;
      keys[v] = item.key;
    });
    paint();
    return cart;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function load() {
    return fetchCart().then(absorb).catch(function () {});
  }

  /* --------------------------------------------------------------- mutate */

  /* The theme's cart bubble and drawer listen for `cart:update` and read
     event.detail.data.itemCount (see assets/cart-icon.js). CartUpdateEvent
     is a plain Event with .detail assigned, so this shape matches it.
     The source tag stops our own listener re-entering on the echo. */
  function broadcast(cart) {
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource: cart,
      sourceId: 'ciy-quick-add',
      data: { itemCount: cart.item_count, source: 'ciy-quick-add' },
    };
    document.dispatchEvent(ev);
  }

  function post(url, body) {
    busy = true;
    paint();

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status));
      })
      /* /cart/add.js answers with the line, not the cart, so re-read either
         way and keep one code path. */
      .then(fetchCart)
      .then(function (cart) {
        absorb(cart);
        broadcast(cart);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        paint();
      });
  }

  /* ---------------------------------------------------------------- click */

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest) return;
      var host = e.target.closest('[data-ciy-qa]');
      if (!host) return;

      var addBtn = e.target.closest('[data-ciy-qa-add]');
      var stepBtn = e.target.closest('[data-ciy-qa-delta]');
      if (!addBtn && !stepBtn) return;

      /* Multi-variant products render the pill as a link to the product
         page — there is no single variant to add blind. Let it navigate. */
      if (addBtn && addBtn.tagName === 'A') return;

      /* The card is wrapped in (or overlaid by) a link to the product page.
         Capture-phase + stopPropagation keeps a pill click off it. */
      e.preventDefault();
      e.stopPropagation();
      if (busy) return;

      var id = host.getAttribute('data-variant-id');

      if (addBtn) {
        post('/cart/add.js', { id: id, quantity: 1 });
        return;
      }

      var key = keys[id];
      if (!key) return;
      var next = (qty[id] || 0) + parseInt(stepBtn.getAttribute('data-ciy-qa-delta'), 10);
      if (next < 0) return;
      post('/cart/change.js', { id: key, quantity: next });
    },
    true
  );

  /* ------------------------------------------------------- stay in sync */

  ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e && e.detail && e.detail.data && e.detail.data.source === 'ciy-quick-add') return;
      setTimeout(load, 150);
    });
  });

  /* Filtering, sorting and "load more" swap the grid out from under us, and
     the carousels are rebuilt on section load. Repaint when cards actually
     appear — matching on [data-ciy-qa] means our own paint() (which only
     touches attributes and the count text inside a pill) cannot retrigger
     this and loop. */
  function watchForNewCards() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches('[data-ciy-qa]') || n.querySelector('[data-ciy-qa]')) {
            paint();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    load();
    watchForNewCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function () {
    setTimeout(load, 60);
  });
})();
